import { Collapse, Stack } from '@mui/material';
import { FunctionComponent, PropsWithChildren, useEffect, useState } from 'react';
import { useResponsive } from 'src/hooks/useResponsive';

const SiteTab: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const isMobile = useResponsive('down', 'md');
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    let lastScrollPosition = 0;
    let touchStartY = 0;

    const handleScroll = () => {
      const currentScrollPosition = Math.max(
        0,
        window.scrollY || document.documentElement.scrollTop
      );

      if (currentScrollPosition === 0) {
        setIsScrolled(false);
      } else if (currentScrollPosition > lastScrollPosition) {
        setIsScrolled(true);
      } else if (currentScrollPosition < lastScrollPosition) {
        setIsScrolled(false);
      }

      lastScrollPosition = currentScrollPosition;
    };

    const handleTouchStart = (e: TouchEvent) => {
      touchStartY = e.touches[0].clientY;
    };

    const handleTouchMove = (e: TouchEvent) => {
      const currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
      if (currentScrollPosition <= 0 && e.touches[0].clientY > touchStartY) {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);
  const navigation = (
    <Stack
      justifyContent={isMobile ? 'center' : 'flex-start'}
      style={{ marginTop: 12 }}
      direction="row"
      alignItems="center"
    >
      {children}
    </Stack>
  );

  return isMobile ? <Collapse in={!isScrolled}>{navigation}</Collapse> : navigation;
};

export default SiteTab;
